import script from "./FederacionView.vue?vue&type=script&setup=true&lang=js"
export * from "./FederacionView.vue?vue&type=script&setup=true&lang=js"

import "./FederacionView.vue?vue&type=style&index=0&id=58926e60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58926e60"]])

export default __exports__